var render = function render(){var _vm=this,_c=_vm._self._c;return _c('invite-members-trigger',{attrs:{"trigger-element":"anchor","display-text":_vm.$options.displayText,"trigger-source":_vm.triggerSource,"classes":"gl-block gl-pl-0 gl-hover-text-decoration-none gl-hover-text-blue-800!"}})
}
var staticRenderFns = []

export { render, staticRenderFns }